import { EVENT_NAMESPACE } from '@/config/constant'
import EventBus from '@/config/EventBus'
import type { ShareParams } from '@/type/share'
import type { BusinessOrder, ChargeCommodity, PaymentCode } from '@kulee/tga-sdk/types/types/wallet'

// Store
export class PopUpStore {
  static menuPopupVisible: boolean = false
  static setMenuPopupVisible = (value: boolean) => {
    this.menuPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static registerPopupVisible: boolean = false
  static setRegisterPopupVisible = (value: boolean) => {
    this.registerPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static loginPopupVisible: boolean = false
  static setLoginPopupVisible = (value: boolean) => {
    this.loginPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static resetPasswordPopupVisible: boolean = false
  static setResetPasswordPopupVisible = (value: boolean) => {
    this.resetPasswordPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static accountSettingPopupVisible: boolean = false
  static setAccountSettingPopupVisible = (value: boolean) => {
    this.accountSettingPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static editEmailPopupVisible: boolean = false
  static setEditEmailPopupVisible = (value: boolean) => {
    this.editEmailPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static editPasswordPopupVisible: boolean = false
  static setEditPasswordPopupVisible = (value: boolean) => {
    this.editPasswordPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static editProfilePopupVisible: boolean = false
  static setEditProfilePopupVisible = (value: boolean) => {
    this.editProfilePopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static editAvatarPopupVisible: boolean = false
  static setEditAvatarPopupVisible = (value: boolean) => {
    this.editAvatarPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static editNicknamePopupVisible: boolean = false
  static setEditNicknamePopupVisible = (value: boolean) => {
    this.editNicknamePopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static editCoverPopupVisible: boolean = false
  static setEditCoverPopupVisible = (value: boolean) => {
    this.editCoverPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static checkinPopupVisible: boolean = false
  static setCheckinPopupVisible = (value: boolean) => {
    this.checkinPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static taskPopupVisible: boolean = false
  static setTaskPopupVisible = (value: boolean) => {
    this.taskPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static achievementPopupVisible: boolean = false
  static setAchievementPopupVisible = (value: boolean) => {
    this.achievementPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static billingPopup: BillingPopupState = {
    visible: false
  }
  static setBillingPopup = (state: BillingPopupState) => {
    this.billingPopup = state
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static topUpGoldPopupVisible: boolean = false
  static setTopUpGoldPopupVisible = (value: boolean) => {
    this.topUpGoldPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static topUpDiamondPopupVisible: boolean = false
  static setTopUpDiamondPopupVisible = (value: boolean) => {
    this.topUpDiamondPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static vipPopupVisible: boolean = false
  static setVIPPopupVisible = (value: boolean) => {
    this.vipPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static vipOrderPopupVisible: boolean = false
  static setVIPOrderPopupVisible = (value: boolean) => {
    this.vipOrderPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static vipOrderDetailPopup: VIPOrderDetailPopupState = {
    visible: false
  }
  static setVIPOrderDetailPopup = (state: VIPOrderDetailPopupState) => {
    this.vipOrderDetailPopup = state
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static vipBenefitPopupVisible: boolean = false
  static setVIPBenefitPopupVisible = (value: boolean) => {
    this.vipBenefitPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static payPopup: PayPopupState = {
    visible: false,
    commodity: undefined,
    createOrder: undefined
  }
  static setPayPopup = (state: PayPopupState) => {
    this.payPopup = state
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static sharePopup: SharePopupState = {
    visible: false
  }
  static setSharePopup = (state: SharePopupState) => {
    this.sharePopup = state
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static invitePopupVisible: boolean = false
  static setInvitePopupVisible = (value: boolean) => {
    this.invitePopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static inviteRecordPopupVisible: boolean = false
  static setInviteRecordPopupVisible = (value: boolean) => {
    this.inviteRecordPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }

  static inviteRewardRecordPopupVisible: boolean = false
  static setInviteRewardRecordPopupVisible = (value: boolean) => {
    this.inviteRewardRecordPopupVisible = value
    EventBus.dispatch(EVENT_NAMESPACE.POPUP)
  }
}

// selector
export class PopupSelector {
  static menuPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.menuPopupVisible
  static registerPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.registerPopupVisible
  static loginPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.loginPopupVisible
  static resetPasswordPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) =>
    store.resetPasswordPopupVisible
  static accountSettingPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) =>
    store.accountSettingPopupVisible
  static editEmailPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.editEmailPopupVisible
  static editPasswordPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.editPasswordPopupVisible
  static editProfilePopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.editProfilePopupVisible
  static editAvatarPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.editAvatarPopupVisible
  static editNicknamePopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.editNicknamePopupVisible
  static editCoverPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.editCoverPopupVisible
  static checkinPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.checkinPopupVisible
  static taskPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.taskPopupVisible
  static achievementPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.achievementPopupVisible
  static billingPopup: SelectorType<BillingPopupState> = (store: typeof PopUpStore) => store.billingPopup
  static topUpGoldPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.topUpGoldPopupVisible
  static topUpDiamondPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.topUpDiamondPopupVisible
  static vipPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.vipPopupVisible
  static vipOrderPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.vipOrderPopupVisible
  static vipOrderDetailPopup: SelectorType<VIPOrderDetailPopupState> = (store: typeof PopUpStore) =>
    store.vipOrderDetailPopup
  static vipBenefitPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.vipBenefitPopupVisible
  static payPopup: SelectorType<PayPopupState> = (store: typeof PopUpStore) => store.payPopup
  static sharePopup: SelectorType<SharePopupState> = (store: typeof PopUpStore) => store.sharePopup
  static invitePopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.invitePopupVisible
  static inviteRecordPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) => store.inviteRecordPopupVisible
  static inviteRewardRecordPopupVisible: SelectorType<boolean> = (store: typeof PopUpStore) =>
    store.inviteRewardRecordPopupVisible
}

type SelectorType<T> = (store: typeof PopUpStore) => T

interface PayPopupState {
  visible: boolean
  commodity?: ChargeCommodity
  quantity?: number
  // 支付币种
  currency?: string
  // 支付币种前缀
  currencyPrefix?: string
  // 支付金额
  amount?: number
  createOrder?: (data: {
    commodity: ChargeCommodity
    quantity: number
    paymentCode: PaymentCode
  }) => Promise<BusinessOrder>
  onSuccess?: (bunessOrder: BusinessOrder) => void
  onError?: (error: Error) => void
}

interface BillingPopupState {
  visible: boolean
  active?: 'GOLD' | 'DIAMOND'
}

interface VIPOrderDetailPopupState {
  visible: boolean
  orderNo?: string
}

interface SharePopupState {
  visible: boolean
  params?: ShareParams | undefined
  onFinish?: () => (void | Promise<void>) | undefined
}
